import { transformGetPathSweeps, transformPathLineInputPath } from 'src/service/navigation/data';
import {
  CombinedSweep,
  ITargetObjectData,
  NavigationType,
  RequestFunction,
} from 'src/service/navigation/types';

export class PathFinder {
  constructor(private tourId: any, private requestFn: RequestFunction, private getPathResult?: { path: any; hasTeleports: any }) {}

  async createPath(
    pathStartSID: string,
    pathEndSID: string,
    pathCalculationSweeps: Map<string, CombinedSweep>,
    targetObjectData?: ITargetObjectData,
    navigationType: NavigationType = NavigationType.Shortest,
  ): Promise<{ path: any; hasTeleports: any }> {
    const isPathCalculated = this.getPathResult && this.getPathResult.path && this.getPathResult.path.length > 0;
    if ((!pathStartSID || !pathEndSID) && !isPathCalculated) {
      console.error('Error creating path');
      return { path: [], hasTeleports: false };
    }

    let res;
    if (isPathCalculated) {
      res = this.getPathResult;
    } else {
      const maxRetries = 3;
      const retryDelay = 200;
      
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          res = await this.requestFn(
            transformGetPathSweeps(pathCalculationSweeps),
            pathStartSID,
            pathEndSID,
            this.tourId,
            navigationType,
          );
          break;
        } catch (error) {
          console.error(`Path request attempt ${attempt} failed:`, error);
          
          if (attempt === maxRetries) {
            console.error('All path request attempts failed, returning empty path');
            return { path: [], hasTeleports: false };
          }
          
          await new Promise(resolve => setTimeout(resolve, retryDelay));
        }
      }
    }

    const path = transformPathLineInputPath(res.path, pathCalculationSweeps);
    if (targetObjectData) {
      path.push({
        data: {
          position: {
            x: targetObjectData.positionX,
            y: targetObjectData.positionY,
            z: targetObjectData.positionZ,
          },
        },
      });
    }
    return { path, hasTeleports: res.hasTeleports };
  }
}
